import React from "react";
import {
  Typography,
  Button,
  Box,
  Container,
  Divider,
  Grid,
} from "@mui/material";
import polygon from "../../static/Home/polygon.svg";
import logo from "../../static/Home/logo.svg";
// import design from "../../static/Home/design.svg";
import laptop from "../../static/Home/laptop.svg";
// import check from "../../static/Home/check.svg";
import mobile1 from "../../static/Home/mobile1.svg";
import mobile2 from "../../static/Home/mobile2.svg";
import studentMgmt from "../../static/Home/studentMgmt.svg";
import attendanceMgmt from "../../static/Home/attendanceMgmt.svg";
import feeMgmt from "../../static/Home/feeMgmt.svg";
import assignmentMgmt from "../../static/Home/assignmentMgmt.svg";
import { useNavigate } from "react-router-dom";
import {
  CheckCircleRounded,
  ChevronRight,
  SystemSecurityUpdateGood,
} from "@mui/icons-material";
import MainContactUs from "./MainContactUs";
import MainFooter from "./MainFooter";

function Home() {
  const navigate = useNavigate();
  return (
    <>
      {/* Banner */}
      <Box
        sx={{
          marginTop: -1.75,
          width: "100%",
          height: "500px",
          backgroundImage: `url(${polygon})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Box
          className="banner"
          sx={{
            display: "flex",
            flexDirection: "column",
            paddingTop: 10,
            paddingLeft: 10,
            color: "#4D4D4D",
          }}
        >
          <img src={logo} alt="SchoolMidas" width="450px" />
          <Typography
            variant="h4"
            sx={{
              fontFamily: "Barlow, sans-serif",
              fontWeight: 500,
              fontSize: 36,
              marginBottom: 1,
            }}
          >
            Best School Management System
          </Typography>
          <Typography
            variant="body1"
            sx={{
              marginTop: 1,
              fontFamily: "Barlow, sans-serif",
              marginBottom: 2,
              color: "#1C408C",
            }}
          >
            SCHOOL MIDAS is a comprehensive tool designed to streamline
            <br /> the administrative and academic operations of educational
            institutions.
          </Typography>
          <Box sx={{ display: "flex" }}>
            <Button
              onClick={() => navigate("/demo")}
              variant="contained"
              sx={{
                backgroundColor: "#F39300",
                color: "#FAFAFA",
                border: "1px solid #FAFAFA",
                marginRight: 2,
                borderRadius: "16px",
                marginTop: 1,
                width: 200,
                textTransform: "unset",
                fontFamily: "Barlow, sans-serif",
                "&:hover": {
                  backgroundColor: "#F39300",
                  color: "#FAFAFA",
                  border: "1px solid #FAFAFA",
                },
              }}
            >
              Request Demo
            </Button>
            <Button
              variant="contained"
              onClick={() => navigate("/contact_us")}
              sx={{
                backgroundColor: "#EDF4FF",
                color: "#025BCF",
                border: "1px solid #025BCF",
                borderRadius: "16px",
                marginTop: 1,
                width: 200,
                textTransform: "unset",
                fontFamily: "Barlow, sans-serif",
                "&:hover": {
                  backgroundColor: "#EDF4FF",
                  color: "#025BCF",
                  border: "1px solid #025BCF",
                },
              }}
            >
              Contact Us <ChevronRight fontSize="small" />
            </Button>
          </Box>
        </Box>
      </Box>

      {/* Intro */}
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: 5,
          marginBottom: 5,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            fontSize: 32,
            color: "#1A1A1A",
            fontFamily: "Barlow, sans-serif",
          }}
        >
          Welcome to SCHOOL MIDAS
        </Typography>
        <Divider
          sx={{
            width: "10%",
            backgroundColor: "#025BCF",
            height: "2px",
          }}
        />
        <Typography
          variant="body1"
          align="center"
          sx={{
            fontWeight: 500,
            fontSize: 16,
            color: "#4D4D4D",
            fontFamily: "Barlow, sans-serif",
            marginTop: 2,
          }}
        >
          SCHOOL MIDAS is a comprehensive tool designed to streamline the
          administrative and academic operations of educational institutions.
          This software aims to enhance the efficiency of managing various
          school activities, ranging from student enrollment and attendance to
          grading and communication.{" "}
        </Typography>
      </Container>

      {/* Works */}
      <Box sx={{ backgroundColor: "#F6F9FF", marginTop: 5, marginBottom: 5 }}>
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              fontSize: 32,
              color: "#1A1A1A",
              fontFamily: "Barlow, sans-serif",
              marginTop: 5,
            }}
          >
            How will SCHOOL MIDAS make Work Easier?
          </Typography>
          <Divider
            sx={{
              width: "20%",
              backgroundColor: "#025BCF",
              height: "2px",
            }}
          />

          <Typography
            sx={{
              fontWeight: 500,
              fontFamily: "Barlow, sans-serif",
              marginTop: 3,
              marginBottom: 3,
              color: "#4D4D4D",
            }}
          >
            Automates routine administrative tasks, allowing staff to focus on
            more critical activities. Enhances communication between teachers,
            students, and parents, ensuring better collaboration. Ensures that
            student and staff data are accurately recorded and securely stored.
            Streamlines fee collection and financial reporting, reducing errors
            and improving transparency.
          </Typography>

          <Grid container sx={{ marginTop: 2, marginBottom: 5 }}>
            <Grid item lg={6} sx={{ marginTop: 2 }}>
              <Box sx={{ display: "flex" }}>
                <img src={studentMgmt} alt="Student" style={{ height: 125 }} />
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  {" "}
                  <Typography
                    variant="h5"
                    sx={{
                      fontFamily: "Barlow, sans-serif",
                      fontWeight: 700,
                      color: "#4E6AF0",
                    }}
                  >
                    STUDENT INFORMATION SYSTEM
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontFamily: "Barlow, sans-serif",
                      fontWeight: 500,
                      fontSize: 14,
                      marginTop: 1,
                      color: "#4D4D4D",
                    }}
                  >
                    <b>Enrollment and Admissions: </b>Automates the student
                    registration and admission process.
                    <br />
                    <b>Attendance Tracking: </b>Records and monitors student
                    attendance.
                    <br />
                    <b>Student Records: </b>Maintains comprehensive student
                    profiles including personal information, academic history,
                    and health records.{" "}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item lg={6} sx={{ marginTop: 2 }}>
              <Box sx={{ display: "flex" }}>
                <img
                  src={attendanceMgmt}
                  alt="Attendance"
                  style={{ height: 125 }}
                />{" "}
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  {" "}
                  <Typography
                    variant="h5"
                    sx={{
                      fontFamily: "Barlow, sans-serif",
                      fontWeight: 700,
                      color: "#4E6AF0",
                    }}
                  >
                    COMMUNICATION TOOLS
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontFamily: "Barlow, sans-serif",
                      fontWeight: 500,
                      fontSize: 14,
                      marginTop: 1,
                      color: "#4D4D4D",
                    }}
                  >
                    <b>Parent-Teacher Communication:</b> Enables direct
                    communication between parents and teachers through messaging
                    or email.
                    <br />
                    <b>Announcements:</b> Broadcasts school-wide announcements
                    and updates.
                    <br />
                    <b>Student Portal:</b> Provides students with access to
                    their academic information, assignments, and resources.{" "}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item lg={6} sx={{ marginTop: 2 }}>
              <Box sx={{ display: "flex" }}>
                <img src={feeMgmt} alt="Fee" style={{ height: 100 }} />{" "}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: 5,
                  }}
                >
                  {" "}
                  <Typography
                    variant="h5"
                    sx={{
                      fontFamily: "Barlow, sans-serif",
                      fontWeight: 700,
                      color: "#4E6AF0",
                    }}
                  >
                    FEE MANAGEMENT
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontFamily: "Barlow, sans-serif",
                      fontWeight: 500,
                      fontSize: 14,
                      marginTop: 1,
                      color: "#4D4D4D",
                    }}
                  >
                    <b>Billing and Invoicing: </b>Automates fee collection and
                    payment processing.
                    <br />
                    <b>Financial Reporting:</b> Generates reports on school
                    finances and budgeting.{" "}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item lg={6} sx={{ marginTop: 2 }}>
              <Box sx={{ display: "flex" }}>
                <img
                  src={attendanceMgmt}
                  alt="Assignment"
                  style={{ height: 100, marginLeft: "10px" }}
                />{" "}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: 3,
                  }}
                >
                  <Typography
                    variant="h5"
                    sx={{
                      fontFamily: "Barlow, sans-serif",
                      fontWeight: 700,
                      color: "#4E6AF0",
                    }}
                  >
                    REPORTING AND ANALYTICS
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontFamily: "Barlow, sans-serif",
                      fontWeight: 500,
                      fontSize: 14,
                      marginTop: 1,
                      color: "#4D4D4D",
                    }}
                  >
                    <b>Custom Reports:</b> Generates various custom reports on
                    student performance, attendance, and more.
                    <br />
                    <b>Data Analytics:</b> Analyzes data to provide insights
                    into school operations and student outcomes.{" "}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Trust */}
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: 5,
          marginBottom: 5,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            fontSize: 32,
            color: "#1A1A1A",
            fontFamily: "Barlow, sans-serif",
          }}
        >
          Why Schools Trust Us?
        </Typography>
        <Divider
          sx={{
            width: "10%",
            backgroundColor: "#025BCF",
            height: "2px",
          }}
        />
        <Grid container sx={{ marginTop: 5 }}>
          <Grid item lg={8}>
            <Typography
              sx={{
                fontSize: 16,
                display: "flex",
                margin: 1,
                fontFamily: "Barlow, sans-serif",
              }}
            >
              {" "}
              <CheckCircleRounded sx={{ color: "#0FA958", marginRight: 1 }} />
              Efficiency and Time-Saving
            </Typography>
            <Typography
              sx={{
                fontSize: 16,
                display: "flex",
                margin: 1,
                fontFamily: "Barlow, sans-serif",
              }}
            >
              {" "}
              <CheckCircleRounded sx={{ color: "#0FA958", marginRight: 1 }} />
              Improved Communication
            </Typography>
            <Typography
              sx={{
                fontSize: 16,
                display: "flex",
                margin: 1,
                fontFamily: "Barlow, sans-serif",
              }}
            >
              {" "}
              <CheckCircleRounded sx={{ color: "#0FA958", marginRight: 1 }} />
              Data Accuracy and Security
            </Typography>
            <Typography
              sx={{
                fontSize: 16,
                display: "flex",
                margin: 1,
                fontFamily: "Barlow, sans-serif",
              }}
            >
              {" "}
              <CheckCircleRounded sx={{ color: "#0FA958", marginRight: 1 }} />
              Enhanced Learning Experience
            </Typography>
            <Typography
              sx={{
                fontSize: 16,
                display: "flex",
                margin: 1,
                fontFamily: "Barlow, sans-serif",
              }}
            >
              {" "}
              <CheckCircleRounded sx={{ color: "#0FA958", marginRight: 1 }} />
              Financial Management
            </Typography>
          </Grid>
          <Grid item lg={4}>
            <img src={laptop} alt="laptop" style={{ height: 250 }} />
          </Grid>
        </Grid>
      </Container>

      {/* Support */}
      <Box
        sx={{
          backgroundColor: "#F39300",
          color: "#FAFAFA",
          marginTop: 5,
          marginBottom: 5,
        }}
      >
        {" "}
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: 5,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              fontSize: 32,
              fontFamily: "Barlow, sans-serif",
            }}
          >
            SCHOOL MIDAS Support is here for You
          </Typography>
          <Divider
            sx={{
              width: "10%",
              backgroundColor: "#FAFAFA",
              height: "2px",
            }}
          />
          <Typography
            variant="body1"
            align="center"
            sx={{
              fontWeight: 500,
              fontSize: 16,

              fontFamily: "Barlow, sans-serif",
              marginTop: 2,
            }}
          >
            You can rely on us for Support and Care
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate("/contact_us")}
            sx={{
              backgroundColor: "#EDF4FF",
              color: "#025BCF",
              border: "1px solid #025BCF",
              borderRadius: "16px",
              marginTop: 3,
              width: 200,
              textTransform: "unset",
              fontFamily: "Barlow, sans-serif",
              "&:hover": {
                backgroundColor: "#EDF4FF",
                color: "#025BCF",
                border: "1px solid #025BCF",
              },
            }}
          >
            Contact Us <ChevronRight fontSize="small" />
          </Button>
        </Container>
      </Box>

      {/* Mobile Apps */}
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: 5,
          marginBottom: 5,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            fontSize: 32,
            color: "#1A1A1A",
            fontFamily: "Barlow, sans-serif",
          }}
        >
          Mobile Apps
        </Typography>
        <Divider
          sx={{
            width: "5%",
            backgroundColor: "#025BCF",
            height: "2px",
          }}
        />
        <Typography
          variant="body1"
          align="center"
          sx={{
            fontWeight: 500,
            fontSize: 16,
            color: "#4D4D4D",
            fontFamily: "Barlow, sans-serif",
            marginTop: 2,
          }}
        >
          Work on your Mobile Without any Hassle!
        </Typography>

        <Grid sx={{ marginTop: 5, display: "flex" }}>
          <Grid item lg={4} sx={{ display: "flex" }}>
            <img
              src={mobile1}
              alt="mobile1"
              height="400px"
              style={{ marginRight: "40px" }}
            />
            <img src={mobile2} alt="mobile1" height="400px" />
          </Grid>
          <Grid item lg={8} paddingLeft={10} paddingTop={3}>
            <Box>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: 24,
                  fontFamily: "Barlow, sans-serif",
                  display: "flex",
                }}
              >
                <SystemSecurityUpdateGood
                  fontSize="large"
                  sx={{ color: "#0FA958" }}
                />{" "}
                Teacher’s App
              </Typography>
              <ul>
                <li>
                  Attendance management, helps schools to maintian records, with
                  cost and staff time saving
                </li>
                <li>
                  Assignment management, helps schools to maintian records, with
                  cost and staff time saving
                </li>
                <li>
                  Communication, helps sending teachers , group announcements
                </li>
                <li>Promots green environment by reducing paper usages</li>
              </ul>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: 24,
                  fontFamily: "Barlow, sans-serif",
                  display: "flex",
                }}
              >
                <SystemSecurityUpdateGood
                  fontSize="large"
                  sx={{ color: "#0FA958" }}
                />{" "}
                Parent’s App
              </Typography>
              <ul>
                <li>Attandace</li>
                <li>Fee Details , payments and receipts</li>
                <li>Assignments</li>
                <li>Announcements</li>
                <li>Push Notifications</li>
              </ul>
            </Box>
          </Grid>
        </Grid>
      </Container>

      {/* ContactUs */}
      <MainContactUs />

      {/* Footer */}
      <MainFooter />
    </>
  );
}

export default Home;
